import {
  FullscreenLoaderActionTypes,
  FullscreenLoaderActions
} from "./actions";

export interface IFullscreenLoaderState {
  requestCount: number;
  loading: boolean;
  text: string;
}

export const initStateFullscreenLoader: IFullscreenLoaderState = {
  loading: false,
  requestCount: 0,
  text: ""
};

export const fullscreenLoaderReducer = (
  state = initStateFullscreenLoader,
  action: FullscreenLoaderActions
) => {
  switch (action.type) {
    case FullscreenLoaderActionTypes.HIDE_LOADING: {
      const count = state.requestCount - 1;
      let loading = false;
      let text = "";
      if (count > 0) {
        loading = true;
        text = state.text;
      }
      return {
        requestCount: count,
        loading,
        text
      };
    }

    case FullscreenLoaderActionTypes.SHOW_LOADING: {
      return {
        requestCount: state.requestCount + 1,
        loading: true,
        text: action.payload
      };
    }

    default: {
      return state;
    }
  }
};
